import { Typography } from "@mui/material";
import { useContext } from "react";

import Context from "../../../context";
import { UnknownTransaction } from "../../../Type";

export default function Description({ description }: UnknownTransaction) {
	const { actions } = useContext(Context);

	return (
		<Typography
			variant='subtitle2'
			onClick={() => actions.showDetailDialog(description)}
			sx={{
				cursor: "pointer",
				"&:hover": {
					textDecoration: "underline"
				}
			}}
		>
			{description}
		</Typography>
	);
}
